import { useContext, useState } from 'react';
import { SearchContext } from 'context/SearchContext';
import { Facets, FilterOption } from 'types/Search';
import React from 'react';
import FilterAccordion from '../SearchFilters/FilterAccordion';
import { SingleSearchFilterItem } from './SingleSearchFilterItem';
import { Box, Divider } from '@mui/material';
import { VirtualizedFilter } from './VirtualizedFilter';
import SimpleBarReact from 'simplebar-react';
import { transformFacetValue } from 'helpers/Search';
import {
  CustomAttributesTypes,
  FilterFacetsTypes
} from 'components/common/Portals/CustomAttributes/types';
import { SingleOptionFilterItem } from './SingleOptionFilterItem';
import { BooleanFilterItem } from './BooleanFilterItem';
interface SearchFilterItemProps {
  option: FilterOption;
  isFirstTextFilter?: boolean;
}

const SearchFilterItem: React.FC<SearchFilterItemProps> = ({
  option,
  isFirstTextFilter
}) => {
  const [searchQuery, setSearchQuery] = useState<string>('');

  const {
    request: searchRequest,
    results: searchResults,
    facetOrder
  } = useContext(SearchContext);

  const selectedFilters = searchRequest.filters
    ?.filter(el => el.field === option.key)
    .map(el => ({
      ...el,
      //get count from searchRequest if its not there it means we have no results
      //we still need to show it as active filter but with 0 count
      count:
        searchResults?.facets[option.key as keyof Facets]?.find(
          filter => filter.value === el.value
        )?.count ?? 0
    }));

  const facets = searchResults?.facets[option.key as keyof Facets] ?? [];

  const filteredFilters = [
    ...facets,
    // add the selected ones which are not in the facets because they have count 0
    ...selectedFilters
      .filter(s => !facets.find(f => f.value === s.value))
      .map(s => ({
        value: s.value,
        count: 0
      }))
  ] //searchquery
    ?.filter(o => {
      if (searchQuery.trim() === '') {
        return true;
      } else {
        return transformFacetValue(option.key, o)
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase().trim());
      }
    })
    //sort by name or count
    .sort((a, b) =>
      facetOrder.value === 'NAME'
        ? transformFacetValue(option.key, a).localeCompare(
            transformFacetValue(option.key, b)
          )
        : b.count - a.count
    );

  const [expanded, setExpanded] = useState<boolean | string>(false);

  if (option.type === FilterFacetsTypes.BOOLEAN) {
    return (
      <>
        {!isFirstTextFilter && <Divider />}
        <BooleanFilterItem
          selectedFilterOption={option.key}
          filter={{
            label: option.label,
            value: option.value,
            key: option.key
          }}
        />
      </>
    );
  }

  return (
    <>
      {(option.type as CustomAttributesTypes) === CustomAttributesTypes.TEXT ? (
        <>
          {!isFirstTextFilter && <Divider />}
          <SingleOptionFilterItem
            selectedFilterOption={option.key}
            filter={{
              value: option.label
            }}
          />
        </>
      ) : (
        <>
          <FilterAccordion
            expanded={expanded}
            setExpanded={setExpanded}
            option={option}
            filteredFilters={filteredFilters}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          >
            {filteredFilters?.length > 500 ? (
              <VirtualizedFilter fullList={filteredFilters} option={option} />
            ) : (
              <SimpleBarReact
                style={{
                  maxHeight: 300,
                  overflowY: 'auto'
                }}
              >
                {filteredFilters?.map(el => (
                  <SingleSearchFilterItem
                    selectedFilterOption={option.key}
                    filter={el}
                    key={el.value}
                  />
                ))}
              </SimpleBarReact>
            )}
          </FilterAccordion>

          {!expanded && selectedFilters && selectedFilters.length > 0 && (
            <Box sx={{ marginTop: -1, marginLeft: '10px' }}>
              {selectedFilters.map(el => (
                <SingleSearchFilterItem
                  selectedFilterOption={option.key}
                  filter={el}
                  key={el.value}
                />
              ))}
            </Box>
          )}
        </>
      )}
    </>
  );
};
export default SearchFilterItem;
